     /**
     * @description
     *  Pais en el que se esta utilizando la aplicacion
     */

    export enum Country {
        NONE,
        ARGENTINA,
        URUGUAY        
    }